// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../css-loader/index.js!./index.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../vue-style-loader/lib/addStylesClient.js")("625f5e56", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./~/vue2-datepicker/index.css
// module id = 1836
// module chunks = 27